export function getTextTrack(textTracks) {
  // textTracks is an object instead of array,
  // so we cannot use iterators
  for (let i = 0; i < textTracks.length; i += 1) {
    if (textTracks[i].kind.toLowerCase() === 'subtitles') {
      return textTracks[i]
    }
  }
  return null
}

export function getTextTracks(textTracks) {
  const tracks = []
  if (!textTracks) return tracks

  // Brightcove returns a TextTrackList, which is array-like but not an array.
  for (let i = 0; i < textTracks.length; i += 1) {
    const kind = textTracks[i].kind.toLowerCase()
    if (kind === 'subtitles' || kind === 'captions') {
      tracks.push(textTracks[i])
    }
  }
  return tracks
}

export function toggleTextTrack(shouldShowTrack, track) {
  const mode = shouldShowTrack ? 'showing' : 'disabled'
  if (!track) return track

  track.mode = mode
  return track
}

export function selectTextTrack(textTracks, selectedTrack) {
  textTracks.forEach(track => {
    track.mode = track === selectedTrack ? 'showing' : 'disabled'
  })
  return selectedTrack
}
